document.addEventListener('DOMContentLoaded', () => {
  initWalkRegistrationForm();
});

function initWalkRegistrationForm() {
  initBlurValidation();
  initGenderToggle();
  initSubmitLogic();
}

const validators = {

  walk_registration_full_name: value =>
    /^[A-Za-z]+(?:\s+[A-Za-z]+)+$/.test(value),

  walk_registration_email: value =>
    /^[A-Za-z0-9]+([._+-]?[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/.test(value),

  walk_registration_mobile: value =>
    /^\d{10}$/.test(value),

  walk_registration_city: value => {

    const cityField =
      document.getElementById('walk_registration_city');

    if (!cityField) return true;

    const isDropdown =
      cityField.dataset.cityDropdown === 'true';

    if (isDropdown) {

      return value.trim() !== '';

    }

    if (value.trim() === '') {

      return true;

    }

    return /^[A-Za-z\s-]{2,}$/.test(value);
  },

  walk_registration_dob: value => {
    if (value.trim() === '') return true;

    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

    const [year, month, day] = value.split('-').map(Number);

    const selectedDate = new Date(year, month - 1, day);

    const today = new Date();
    today.setHours(0,0,0,0);

    return (
      selectedDate instanceof Date &&
      !isNaN(selectedDate.getTime()) &&
      selectedDate <= today
    );
  }
};

function toggleError(fieldId, isValid) {

  const errorEl = document.getElementById(`${fieldId}Error`);

  if (!errorEl) return;

  isValid
    ? errorEl.classList.add('hidden')
    : errorEl.classList.remove('hidden');
}

function validateField(field) {

  const validator = validators[field.id];

  if (!validator) return true;

  const isValid = validator(field.value.trim());

  toggleError(field.id, isValid);

  return isValid;
}

function initBlurValidation() {

  const form = document.getElementById('walk-registration-form');

  if (!form) return;

  const fields = form.querySelectorAll('input, select');

  fields.forEach(field => {

    field.addEventListener('blur', () => validateField(field));

    field.addEventListener('input', () => validateField(field));

  });

  const cityField = document.getElementById('walk_registration_city');

  if (
    cityField &&
    cityField.tagName === 'INPUT'
  ) {

    cityField.addEventListener('input', () => {

      cityField.value =
        cityField.value.replace(/[^A-Za-z\s-]/g, '');

    });

  }
}

function initGenderToggle() {

  const genderGroup = document.getElementById('walk_registration_gender');

  if (!genderGroup) return;

  const buttons = genderGroup.querySelectorAll('.walk-registration-gender-option');

  buttons.forEach(button => {

    button.addEventListener('click', () => {

      buttons.forEach(btn => btn.classList.remove('checked'));

      button.classList.add('checked');

    });

  });
}

function initSubmitLogic() {

  const form = document.getElementById('walk-registration-form');

  const submitBtn = document.getElementById('walk_registration_submit_button');

  const submitText = submitBtn?.querySelector('.walk-registration-submit-text');

  const loader = submitBtn?.querySelector('.loading-overlay');

  const formError = document.getElementById('walk_registration_formErrorMessage');

  const formSuccess = document.getElementById('walk_registration_formSuccessMessage');

  if (!form || !submitBtn) return;

  const SCRIPT_URL =
    'https://script.google.com/macros/s/AKfycbzEhW2YLSJo7CHnzP7FT71QSFlyc1HgtEhbRm3s_WUXr5_LcTv2BZ6CvMd45UncqmEw1w/exec';

  const fields = {
    fullName: document.getElementById('walk_registration_full_name'),
    email: document.getElementById('walk_registration_email'),
    mobile: document.getElementById('walk_registration_mobile'),
    city: document.getElementById('walk_registration_city'),
    dob: document.getElementById('walk_registration_dob'),
    gender: document.getElementById('walk_registration_gender')
  };

  function showLoader() {

    submitBtn.disabled = true;

    loader.style.opacity = '1';

    submitText.style.opacity = '0';
  }

  function hideLoader() {

    loader.style.opacity = '0';

    submitText.style.opacity = '1';
  }

  function validateAllFields() {

    let valid = true;

    Object.values(fields).forEach(field => {

      if (!field || field.tagName === 'DIV') return;

      const isValid = validateField(field);

      if (!isValid) {
        valid = false;
      }

    });

    return valid;
  }

  form.addEventListener('submit', async (e) => {

    e.preventDefault();

    formError.classList.add('hidden');

    formSuccess.classList.add('hidden');

    const isValid = validateAllFields();

    if (!isValid) {
      formError.classList.remove('hidden');
      return;
    }

    showLoader();

    const payload = {

      timestamp: new Date().toISOString(),

      fullName: fields.fullName.value.trim(),

      email: fields.email.value.trim(),

      mobile: fields.mobile.value.trim(),

      city: fields.city.value.trim(),

      dob: fields.dob.value,

      gender:
        fields.gender.querySelector('.checked')?.dataset.value || ''
    };

    try {

      const formData = new FormData();

      Object.keys(payload).forEach(key => {

        formData.append(key, payload[key]);

      });

      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        body: formData
      });

      const text = await response.text();

      let result;

      try {
        result = JSON.parse(text);
      } catch {
        result = { success: true };
      }

      hideLoader();

      if (!result.success) {

        formError.textContent = result.message || 'Submission failed';

        formError.classList.remove('hidden');

        submitBtn.disabled = false;

        return;
      }

      form.reset();

      fields.gender
        .querySelectorAll('.checked')
        .forEach(btn => btn.classList.remove('checked'));

      formSuccess.classList.remove('hidden');

      submitBtn.disabled = false;

      // ===== MoEngage =====

      if (typeof Moengage !== 'undefined') {

        const nameParts = payload.fullName.split(/\s+/);

        const firstName = nameParts.shift();

        const lastName = nameParts.join(' ');

        Moengage.add_first_name(firstName);

        Moengage.add_last_name(lastName);

        Moengage.add_email(payload.email);

        Moengage.add_mobile(payload.mobile);

        if (payload.gender) {
          Moengage.add_gender(payload.gender);
        }

        if (payload.city) {
          Moengage.add_user_attribute('City', payload.city);
        }

        if (payload.dob) {
          Moengage.add_user_attribute('Date of Birth', payload.dob);
        }

        Moengage.track_event('Walk Naturally Registration Submitted', {

          "User ID": payload.email,
          "First Name": firstName,
          "Last Name": lastName,
          "Email": payload.email,
          "Mobile": payload.mobile,
          "Gender": payload.gender,
          "City": payload.city,
          "Date of Birth": payload.dob,
          "Source": "Shopify",
          "Brand": "Birkenstock"

        });
      }

    } catch (error) {

      hideLoader();

      formError.textContent =
        'Unable to connect. Please try again.';

      formError.classList.remove('hidden');

      submitBtn.disabled = false;
    }
  });
}